import React from "react";

const Stat_Histograms = () => {
  return (
    <div>
      <h1>Stat Histograms</h1>
    </div>
  );
};

export default Stat_Histograms;
